import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
export class Accuracy {
    constructor(params = {}) {
        this.seconds = 0;
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.Integer, optional: true })
], Accuracy.prototype, "seconds", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer, context: 0, implicit: true, optional: true })
], Accuracy.prototype, "millis", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer, context: 1, implicit: true, optional: true })
], Accuracy.prototype, "micros", void 0);
